export default {
  token: null,
  token_type: null,
  profile: null,
  resendOTP: null,
  OTPFlag: {},
  errors: [],
};
